export interface Category {
  id: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Pair%20of%20crisp%20white%20leather%20sneakers%20with%20subtle%20grey%20accents%20placed%20on%20a%20light%20apricot%20linen%20surface%20with%20soft%20daylight%20from%20the%20left%20and%20a%20gentle%20shadow%2C%20clean%20minimal%20Scandinavian%20product%20photography%20with%20generous%20negative%20space&width=600&height=600&seq=cat-shoes&orientation=squarish&nocache=true",
  },
  {
    id: "hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Hoodies.html",
    image:
      "https://readdy.ai/api/search-image?query=Oversized%20heathered%20oatmeal%20hoodie%20casually%20draped%20over%20a%20wooden%20hanger%20against%20a%20soft%20sage%20green%20wall%20with%20warm%20diffused%20lighting%2C%20cozy%20editorial%20catalog%20photography%20with%20natural%20fabric%20texture%20and%20relaxed%20composition&width=600&height=600&seq=cat-hoodies&orientation=squarish&nocache=true",
  },
  {
    id: "tshirts",
    url: "https://kaspreadsheet.com/search-913/name/T-Shirts.html",
    image:
      "https://readdy.ai/api/search-image?query=Plain%20white%20crewneck%20t-shirt%20folded%20neatly%20on%20a%20light%20sand%20colored%20stone%20table%20beside%20a%20small%20green%20leaf%2C%20bright%20airy%20daylight%2C%20crisp%20contemporary%20e-commerce%20product%20shot%20with%20minimal%20styling&width=600&height=600&seq=cat-tshirts&orientation=squarish&nocache=true",
  },
  {
    id: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Jackets.html",
    image:
      "https://readdy.ai/api/search-image?query=Slim%20tan%20bomber%20jacket%20hanging%20on%20a%20minimal%20brass%20coat%20rack%20against%20a%20warm%20ivory%20plaster%20wall%20with%20soft%20morning%20light%2C%20premium%20editorial%20fashion%20photography%20with%20elegant%20simple%20composition%20and%20soft%20shadows&width=600&height=600&seq=cat-jackets&orientation=squarish&nocache=true",
  },
  {
    id: "pants",
    url: "https://kaspreadsheet.com/search-915/name/Pants.html",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20folded%20olive%20green%20chino%20pants%20stacked%20on%20a%20pale%20cream%20wooden%20bench%20with%20soft%20natural%20window%20light%2C%20minimal%20menswear%20product%20photography%20with%20visible%20fabric%20weave%20and%20tidy%20editorial%20styling&width=600&height=600&seq=cat-pants&orientation=squarish&nocache=true",
  },
  {
    id: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Headwear.html",
    image:
      "https://readdy.ai/api/search-image?query=Classic%20camel%20brown%20baseball%20cap%20resting%20on%20a%20stack%20of%20light%20grey%20books%20on%20a%20pale%20blush%20table%20with%20soft%20diffused%20daylight%2C%20clean%20contemporary%20lifestyle%20product%20photography%20with%20minimal%20composition&width=600&height=600&seq=cat-headwear&orientation=squarish&nocache=true",
  },
  {
    id: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Sets.html",
    image:
      "https://readdy.ai/api/search-image?query=Coordinated%20cream%20and%20beige%20loungewear%20set%20laid%20flat%20on%20a%20light%20terracotta%20background%20with%20soft%20overhead%20lighting%2C%20minimal%20fashion%20flat%20lay%20photography%20with%20neat%20symmetrical%20composition%20and%20gentle%20folds&width=600&height=600&seq=cat-sets&orientation=squarish&nocache=true",
  },
  {
    id: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Underwear.html",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20folded%20in%20a%20small%20neat%20stack%20on%20a%20crisp%20white%20marble%20surface%20beside%20a%20sprig%20of%20eucalyptus%2C%20bright%20clean%20daylight%2C%20premium%20minimal%20product%20photography%20with%20a%20fresh%20spa-like%20aesthetic&width=600&height=600&seq=cat-underwear&orientation=squarish&nocache=true",
  },
  {
    id: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Jersey.html",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20sports%20jersey%20in%20deep%20forest%20green%20with%20white%20trim%20displayed%20on%20a%20mannequin%20against%20a%20pale%20grey%20studio%20wall%20with%20soft%20even%20lighting%2C%20clean%20athletic%20product%20photography%20with%20a%20simple%20focused%20composition&width=600&height=600&seq=cat-jersey&orientation=squarish&nocache=true",
  },
  {
    id: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Accessories.html",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20watch%20with%20a%20brown%20leather%20strap%20and%20a%20simple%20silver%20bracelet%20arranged%20on%20a%20light%20beige%20linen%20cloth%2C%20soft%20natural%20light%2C%20refined%20contemporary%20editorial%20product%20photography%20with%20elegant%20styling&width=600&height=600&seq=cat-accessories&orientation=squarish&nocache=true",
  },
  {
    id: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Bags.html",
    image:
      "https://readdy.ai/api/search-image?query=Structured%20natural%20canvas%20tote%20bag%20leaning%20against%20a%20pale%20oak%20shelf%20beside%20a%20small%20potted%20green%20plant%2C%20warm%20diffused%20daylight%2C%20airy%20organic%20lifestyle%20product%20photography%20with%20minimal%20composition&width=600&height=600&seq=cat-bags&orientation=squarish&nocache=true",
  },
  {
    id: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Belts.html",
    image:
      "https://readdy.ai/api/search-image?query=Handmade%20brown%20leather%20belt%20coiled%20elegantly%20on%20a%20light%20warm%20grey%20stone%20surface%20with%20soft%20directional%20lighting%2C%20premium%20minimal%20accessory%20photography%20showing%20visible%20stitching%20and%20refined%20composition&width=600&height=600&seq=cat-belts&orientation=squarish&nocache=true",
  },
  {
    id: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Perfumes.html",
    image:
      "https://readdy.ai/api/search-image?query=Clear%20glass%20perfume%20bottle%20with%20amber%20liquid%20standing%20on%20a%20pale%20green%20marble%20ledge%20with%20soft%20botanical%20shadows%20and%20gentle%20daylight%2C%20elegant%20minimal%20beauty%20product%20photography%20with%20a%20fresh%20refined%20aesthetic&width=600&height=600&seq=cat-perfumes&orientation=squarish&nocache=true",
  },
  {
    id: "other",
    url: "https://kaspreadsheet.com/search-924/name/Other.html",
    image:
      "https://readdy.ai/api/search-image?query=Eclectic%20arrangement%20of%20small%20fashion%20accessories%20including%20sunglasses%20a%20leather%20wallet%20and%20a%20metal%20keychain%20on%20a%20warm%20cream%20canvas%20with%20soft%20diffused%20light%2C%20minimal%20still%20life%20product%20photography%20with%20a%20playful%20yet%20tidy%20composition&width=600&height=600&seq=cat-other&orientation=squarish&nocache=true",
  },
];

export const heroBackgroundImage =
  "https://readdy.ai/api/search-image?query=Bright%20editorial%20flat%20lay%20collage%20of%20assorted%20streetwear%20essentials%20including%20sneakers%20hoodies%20caps%20bags%20and%20accessories%20scattered%20artfully%20on%20a%20warm%20cream%20background%20with%20soft%20natural%20shadows%2C%20lots%20of%20negative%20space%2C%20fresh%20modern%20high%20detail%20product%20photography&width=1600&height=900&seq=hero-bg&orientation=landscape&nocache=true";